export const LeadDetail = () => {
  return (
    <div>
      <h1>Lead Detail</h1>
    </div>
  );
};
